import { useCallback, useEffect, useState } from 'react';

/**
 * Progreso del curso: set de slugs vistos en localStorage.
 * Todo con try/catch: en modo privado o con el storage bloqueado el curso funciona igual,
 * solo que el progreso dura lo que dura la pestaña.
 */
export const CURSO_STORAGE_KEY = 'dashflow-curso-v1';

const read = (): string[] => {
  try {
    const raw = window.localStorage.getItem(CURSO_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((x) => typeof x === 'string') : [];
  } catch {
    return [];
  }
};

const write = (slugs: string[]) => {
  try {
    window.localStorage.setItem(CURSO_STORAGE_KEY, JSON.stringify(slugs));
  } catch {
    /* sin storage: queda en memoria */
  }
};

export const useCursoProgress = () => {
  const [vistas, setVistas] = useState<Set<string>>(() => new Set(read()));

  // Si el curso está abierto en otra pestaña, mantener las dos al día.
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === CURSO_STORAGE_KEY) setVistas(new Set(read()));
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const marcarVista = useCallback((slug: string) => {
    setVistas((prev) => {
      if (prev.has(slug)) return prev;
      const next = new Set(prev);
      next.add(slug);
      write(Array.from(next));
      return next;
    });
  }, []);

  return { vistas, marcarVista };
};
